if (!customElements.get('lai-cart-discount')) {
  customElements.define('lai-cart-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => event.stopPropagation());
      this.querySelector('form').addEventListener('submit', event => this.applyCode(event));
    }
    async applyCode(event) {
      event.preventDefault();
      event.stopPropagation();
      const input = this.querySelector('input');
      const code = input.value.trim();
      if (!code) { input.focus(); return; }
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      const label = button.textContent;
      const context = this.dataset.context;
      const messages = {...this.dataset};
      button.disabled = true;
      button.textContent = messages.busy;
      status.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const beforeResponse = await fetch(root + 'cart.js', {headers: {'Accept':'application/json'}});
        if (!beforeResponse.ok) throw new Error('Cart unavailable');
        const before = await beforeResponse.json();
        const applications = [
          ...(before.cart_level_discount_applications || []),
          ...(before.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))
        ];
        const existing = applications.filter(a => a.type === 'discount_code').map(a => a.title);
        (before.discount_codes || []).filter(d => d.applicable).forEach(d => existing.push(d.code));
        const codes = [...new Set([...existing, code].map(c => c.toUpperCase()))];
        const main = document.querySelector('#main-cart-footer');
        const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
        if (main?.dataset.id) sectionIds.push(main.dataset.id);
        const response = await fetch(root + 'cart/update.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({discount:codes.join(','), sections:sectionIds, sections_url:window.location.pathname})
        });
        if (!response.ok) throw new Error('Discount unavailable');
        const cart = await response.json();
        const applied = [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))
        ].some(a => a.title?.toUpperCase() === code.toUpperCase());
        const codeResult = (cart.discount_codes || []).find(d => d.code.toUpperCase() === code.toUpperCase());
        const message = applied ? messages.success : codeResult?.applicable ? messages.shipping : messages.invalid;
        let rendered = false;
        for (const [id, html] of Object.entries(cart.sections || {})) {
          if (!html) continue;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          if (id === 'cart-drawer') {
            const target = document.querySelector('#CartDrawer');
            const source = doc.querySelector('#CartDrawer');
            if (target && source) { target.innerHTML = source.innerHTML; rendered = true; }
          } else if (id === 'cart-icon-bubble') {
            const target = document.querySelector('#cart-icon-bubble');
            const source = doc.querySelector('.shopify-section');
            if (target && source) target.innerHTML = source.innerHTML;
          } else {
            const target = document.querySelector('cart-items');
            const source = doc.querySelector('cart-items');
            if (target && source) { target.innerHTML = source.innerHTML; rendered = true; }
          }
        }
        if (!rendered) { window.location.reload(); return; }
        const current = document.querySelector('lai-cart-discount[data-context="' + context + '"]');
        if (current) {
          current.querySelector('details').open = true;
          current.querySelector('input').value = code;
          current.querySelector('[role="status"]').textContent = message;
          current.querySelector('input').focus();
        }
      } catch (error) { status.textContent = messages.error; }
      finally { button.disabled = false; button.textContent = label; }
    }
  });
}
